import React from 'react';
import PropTypes from 'prop-types';

export default class TooltipExpandingSection extends React.Component {
  constructor(props) {
    super(props);

    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    if (this.props.expanded) {
      this.props.minimizeSection();
    } else {
      this.props.expandSection(this.props.sectionIdx);
    }
  }

  render() {
    const sectionTitle = `STEP ${this.props.sectionIdx + 1}`;
    return (
      <div className="expand-tip-section">
        <div className="section-header">
          <div className="section-title">
            {sectionTitle}
          </div>
          <button
            className="expand-tip-button"
            onClick={this.toggleCollapse}
          >
            <img
              alt="Expand"
              className={this.props.expanded ? 'minimize-button-img' : 'expand-button-img'}
              src={this.props.expanded ? '/images/self-serve-builder/minus-icon-white-2x.png' : '/images/self-serve-builder/plus-icon-white-2x.png'}
            />
          </button>
        </div>
        <div className={this.props.expanded ? 'step-contents expanded' : 'collapsed'}>
          <div className="section-text" >
            {this.props.sectionText}
            { this.props.sectionAdditionalText &&
              <div className="popover-additional-text">{this.props.sectionAdditionalText}</div>
            }
          </div>
          <img
            alt=""
            className="section-image"
            src={this.props.sectionImg}
          />
        </div>
      </div>
    );
  }
}

TooltipExpandingSection.defaultProps = {
  sectionAdditionalText: null,
};

TooltipExpandingSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  expandSection: PropTypes.func.isRequired,
  minimizeSection: PropTypes.func.isRequired,
  sectionIdx: PropTypes.number.isRequired,
  sectionImg: PropTypes.string.isRequired,
  sectionText: PropTypes.string.isRequired,
  sectionAdditionalText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/TooltipExpandingSection.jsx